export function Sidebar({ groups, view, groupId, onNav, onGroupNav, onAddGroup }) {
  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <div className="logo-icon">💸</div>
        Splitwise
      </div>

      <nav className="nav">
        {[
          { id: 'dashboard', label: 'Dashboard', icon: '⊞' },
          { id: 'friends', label: 'Friends', icon: '👥' },
          { id: 'activity', label: 'Activity', icon: '📋' },
        ].map(item => (
          <button
            key={item.id}
            className={`nav-item${view === item.id && !groupId ? ' active' : ''}`}
            onClick={() => onNav(item.id)}
          >
            <span style={{ fontSize: 15 }}>{item.icon}</span>
            {item.label}
          </button>
        ))}
      </nav>

      <div style={{ padding: '0 0.5rem' }}>
        <div className="groups-label">Groups</div>
        {groups.map(g => (
          <button
            key={g.id}
            className={`group-nav-item${groupId === g.id ? ' active' : ''}`}
            onClick={() => onGroupNav(g.id)}
          >
            <span className="group-dot" style={{ background: g.color }} />
            {g.name}
          </button>
        ))}
      </div>

      <div className="sidebar-footer">
        <button className="nav-item" style={{ width: '100%' }} onClick={onAddGroup}>
          <span>＋</span> Add group
        </button>
      </div>
    </aside>
  );
}
